import { useState } from 'react';

interface BocuseImageProps {
  src?: string | null;
  /** Nom de la maison — affiché en signature rouge dans le fallback marine. */
  name: string;
  className?: string;
}

/**
 * Image avec fallback marine élégant. La source Ciss (ciss-api) ne renvoie pas
 * encore de visuels exploitables pour Bocuse ; le fallback (signature rouge sur
 * fond marine) est donc le visuel par défaut, cohérent avec la charte, en
 * attendant les assets officiels.
 */
export function BocuseImage({ src, name, className }: BocuseImageProps) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;
  return (
    <div className={`mb-img${className ? ` ${className}` : ''}`}>
      {showImage ? (
        <img src={src as string} alt={name} loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <div className="mb-img-fallback">
          <span className="mb-img-fallback-name">{name}</span>
        </div>
      )}
    </div>
  );
}
